export const removeTags = (str) => {
  if (!str) return '';
  const newStr = str.toString();
  return newStr.replace(/(<([^>]+)>)/gi, '');
};
